import React from 'react'

const PioneerGrayLogo: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="140"
    height="36"
    viewBox="0 0 140 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_30479_11150)">
      <path
        d="M10.8864 0C10.8991 0.0802821 10.921 0.158697 10.921 0.238979C10.921 12.0871 10.921 23.9371 10.921 35.7853V36.0019H8.72945C8.7258 35.9272 8.71851 35.8469 8.71851 35.7685C8.71851 23.9278 8.71851 12.0853 8.71851 0.24458C8.71851 0.164298 8.73309 0.0821492 8.74038 0.00186703C9.45511 0.00186703 10.1698 0.00186703 10.8846 0.00186703L10.8864 0Z"
        fill="#8F98A1"
      />
      <path
        d="M92.7265 20.8169V23.005H105.592V25.2193H92.7265V27.3926H105.588V29.6087H90.5641V18.625H105.588V20.8169H92.7265Z"
        fill="#8F98A1"
      />
      <path
        d="M122.777 18.627V20.8095H109.923V22.9939H122.772V25.2138H109.916V27.3908H122.774V29.6013H107.75V18.627H122.777Z"
        fill="#8F98A1"
      />
      <path
        d="M138.915 25.5705C139.457 26.1474 139.83 26.8064 139.918 27.5813C139.993 28.2441 139.974 28.9181 140 29.6033H137.827C137.827 29.1757 137.848 28.7519 137.819 28.3318C137.801 28.0555 137.754 27.7624 137.639 27.5159C137.385 26.9745 136.924 26.687 136.341 26.6851C133.309 26.6758 130.276 26.6814 127.244 26.6814C127.201 26.6814 127.159 26.687 127.089 26.6926V29.6051H124.943V18.6102H125.171C128.86 18.6102 132.546 18.6083 136.235 18.6102C138.209 18.6102 139.736 19.9675 139.956 21.969C140.102 23.3002 139.923 24.566 138.917 25.5705H138.915ZM127.091 24.4596C127.148 24.4652 127.177 24.4708 127.206 24.4708C130.26 24.4708 133.312 24.4745 136.366 24.4689C137.079 24.4689 137.699 23.9014 137.792 23.1732C137.83 22.8726 137.839 22.5608 137.812 22.2602C137.732 21.3809 137.108 20.817 136.244 20.817C133.278 20.817 130.313 20.817 127.346 20.817C127.263 20.817 127.179 20.817 127.091 20.817V24.4596Z"
        fill="#8F98A1"
      />
      <path
        d="M63.6977 18.6175C65.0524 18.6175 66.4089 18.5988 67.7636 18.6231C69.4064 18.6529 70.9252 20.0457 71.164 21.7111C71.1968 21.9464 71.2133 22.1854 71.2151 22.4225C71.2205 23.5707 71.2187 24.7189 71.2169 25.8671C71.2151 27.9395 69.6015 29.6086 67.5704 29.618C64.9904 29.6292 62.4105 29.6273 59.8306 29.618C57.7776 29.6105 56.1694 27.9395 56.1694 25.8354C56.1694 24.7021 56.1694 23.5688 56.1694 22.4355C56.1694 20.2548 57.7593 18.6193 59.8944 18.6119C61.1616 18.6063 62.4305 18.6119 63.6977 18.6119C63.6977 18.6137 63.6977 18.6175 63.6977 18.6193V18.6175ZM63.6923 27.3962C64.9667 27.3962 66.243 27.3962 67.5175 27.3962C68.4145 27.3962 69.06 26.7353 69.06 25.8205C69.06 24.6872 69.06 23.5539 69.06 22.4206C69.06 21.4815 68.4109 20.8168 67.4901 20.8168C64.954 20.8168 62.4196 20.8168 59.8834 20.8168C58.99 20.8168 58.3337 21.4777 58.3282 22.3907C58.3227 23.5389 58.3227 24.6872 58.3282 25.8354C58.3337 26.7446 58.9791 27.3962 59.8652 27.3962C61.1397 27.3962 62.416 27.3962 63.6904 27.3962H63.6923Z"
        fill="#8F98A1"
      />
      <path
        d="M36.8393 26.6803V29.6022H34.6987V18.6204C34.7753 18.6166 34.8464 18.611 34.9175 18.611C38.6133 18.611 42.3072 18.6073 46.003 18.611C47.8409 18.6129 49.3268 19.8041 49.6532 21.6319C49.9066 23.0415 49.7681 24.4063 48.7306 25.5134C48.005 26.2882 47.1097 26.6803 46.0559 26.6803C43.0821 26.6803 40.1084 26.6803 37.1364 26.6803C37.0489 26.6803 36.9632 26.6803 36.8411 26.6803H36.8393ZM36.8465 24.4604C36.9085 24.466 36.9505 24.4716 36.9942 24.4716C40.0336 24.4716 43.0712 24.4754 46.1106 24.4716C46.8253 24.4716 47.4507 23.9097 47.5455 23.1871C47.5838 22.9015 47.5929 22.6065 47.5747 22.3189C47.5218 21.4265 46.8818 20.8216 46.0103 20.8216C43.0366 20.8216 40.0646 20.8216 37.0909 20.8216C37.0125 20.8216 36.9359 20.8216 36.8465 20.8216V24.4642V24.4604Z"
        fill="#8F98A1"
      />
      <path
        d="M4.37793 3.27734H6.53486V35.0299H4.37793V3.27734Z"
        fill="#8F98A1"
      />
      <path
        d="M75.5161 20.8181V29.6062H73.3646V18.6094C73.4448 18.6094 73.5214 18.6094 73.598 18.6094C77.2865 18.6094 80.975 18.6094 84.6634 18.6094C86.6034 18.6094 88.093 19.9238 88.3793 21.8804C88.4012 22.0354 88.4066 22.1922 88.4066 22.349C88.4066 24.6977 88.4066 27.0465 88.4066 29.3971C88.4066 29.4624 88.3993 29.5277 88.3957 29.6062H86.2497C86.2497 29.5091 86.2497 29.4213 86.2497 29.3354C86.2497 27.039 86.2497 24.7407 86.2497 22.4442C86.2497 21.4753 85.6061 20.8181 84.6562 20.8181C81.7043 20.8181 78.7524 20.8181 75.7987 20.8181C75.713 20.8181 75.6273 20.8181 75.5143 20.8181H75.5161Z"
        fill="#8F98A1"
      />
      <path
        d="M15.2663 34.0555H13.0966V3.2832H15.2663V34.0555Z"
        fill="#8F98A1"
      />
      <path
        d="M17.4758 6.50781H19.6364V32.1122H17.4758V6.50781Z"
        fill="#8F98A1"
      />
      <path d="M0 17.0156H2.16787V32.1105H0V17.0156Z" fill="#8F98A1" />
      <path
        d="M54.0111 29.6068H51.8925V18.625H54.0111V29.6068Z"
        fill="#8F98A1"
      />
    </g>
    <defs>
      <clipPath id="clip0_30479_11150">
        <rect width="140" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default PioneerGrayLogo
